var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReferrer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99908 0.333008L10.8164 4.45529L15.6075 5.86087L12.5576 9.81414L12.7013 14.8051L7.99908 13.1261L3.2968 14.8051L3.44054 9.81414L0.390625 5.86087L5.18175 4.45529L7.99908 0.333008ZM6.66574 7.99967H5.33241C5.33241 9.47241 6.52632 10.6663 7.99908 10.6663C9.42722 10.6663 10.5931 9.54367 10.6625 8.13274L10.6657 7.99967H9.33242C9.33242 8.73607 8.73548 9.33301 7.99908 9.33301C7.29615 9.33301 6.72028 8.78907 6.66942 8.09921L6.66574 7.99967Z",
    fill: "#8CA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReferrer);
export default __webpack_public_path__ + "static/media/icon_referrer.fd2d63f2280c38efaf1af6c40b3c7938.svg";
export { ForwardRef as ReactComponent };